/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);



/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/

if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}
// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),

    // Navigation
    $header                  : $('header'),
    $megamenuNav               : $('.megamenuNav'),
    $aniNav                  : $('#megamenuMenu'),
    $searchForm              : $('#headerSearch'),
    $searchStore             : $('#searchStore'),
    $closeSearch             : $('#closeSearch'),
    $navigation              : $('#AccessibleNav'),
    
    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('.featuredImage img'),
    $thumbImages             : $('.productThumbs a'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};


timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.productImageSwitch();
  timber.loginForms();
  timber.navMenu();
  timber.accessibleNav();
  
};


timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('.featuredImage img'),
      $productImage_stickycart = $('#featuredImage_stickycart img'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $productPrice_stickycart = $('#ProductPrice_stickycart'),
      $comparePrice_stickycart = $('#ComparePrice_stickycart'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');
  	  $addToCartAll = $('.add_to_cart_btn');
  	$addToCartTextAll = $('.add_to_cart_btn #AddToCartText');

  if (variant) {
   

    // Update variant image, if one is set
    if (variant.featured_image) {
      
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }
    if (variant.featured_image) {
      
      var newImg1 = variant.featured_image,
          el = $productImage_stickycart[0];
      Shopify.Image.switchImage(newImg1, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCartAll.removeClass('disabled').prop('disabled', false);
      $addToCartTextAll.html($addToCart.attr('data-text'));
      $quantityElements.show();
    } else {
      
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCartAll.addClass('disabled').prop('disabled', true);
      $addToCartTextAll.html("Sold");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
    $productPrice_stickycart.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }
    if (variant.compare_at_price > variant.price) {
      $comparePrice_stickycart
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice_stickycart.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCartAll.addClass('disabled').prop('disabled', true);
    $addToCartTextAll.html("Sold");
    $quantityElements.hide();
  }
};

timber.productPageRegular = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('.featuredImage img'),
      $productImage_stickycart = $('#featuredImage_stickycart img'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $productPrice_stickycart = $('#ProductPrice_stickycart'),
      $comparePrice_stickycart = $('#ComparePrice_stickycart'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');
  		$addToCartAll = $('.add_to_cart_btn');
  	$addToCartTextAll = $('.add_to_cart_btn #AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }
    if (variant.featured_image) {
      
      var newImg1 = variant.featured_image,
          el = $productImage_stickycart[0];
      Shopify.Image.switchImage(newImg1, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCartAll.removeClass('disabled').prop('disabled', false);
      $addToCartTextAll.html($addToCart.attr('data-text'));
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCartAll.addClass('disabled').prop('disabled', true);
      $addToCartTextAll.html("Sold");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
    $productPrice_stickycart.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }
    if (variant.compare_at_price > variant.price) {
      $comparePrice_stickycart
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice_stickycart.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCartAll.addClass('disabled').prop('disabled', true);
    $addToCartTextAll.html("Sold");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
 
  //if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('tap', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.cache.$thumbImages.removeClass('active');
      $(this).addClass('active');
      timber.switchImage(newImage, null, timber.cache.$productImage);
      return false;
    });
  	timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.cache.$thumbImages.removeClass('active');
      $(this).addClass('active');
      timber.switchImage(newImage, null, timber.cache.$productImage);
      return false;
    });
  //}
};

// $(document).ready(function() {
// $( "#thumbs_list li" ).on('click', function(evt) {
//   alert('hi');
// });
// });


timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);

  $(".productThumbs a.active").removeClass('active');
  $(".productThumbs a[href='"+src+"']").addClass('active');

};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};



timber.navMenu = function(){
  
  timber.openMenu = function(){
    timber.cache.$megamenuNav.addClass('active');
    timber.cache.$aniNav.addClass('active');
    $('body').addClass('open_mobile_menu');
  }

 
  timber.closeMenu = function(){
    timber.cache.$megamenuNav.removeClass('active');
    timber.cache.$aniNav.removeClass('active');
    $('body').removeClass('open_mobile_menu');
  }
  
  
  timber.cache.$megamenuNav.on('click', function(evt) {
    evt.preventDefault();
    if(!$(this).hasClass('active')){
      
      timber.openMenu();
    }else{
      timber.closeMenu();  
    }
  }); 
  
 
   timber.cache.$aniNav.find('.parentLink').on('click', function(evt) {
     evt.preventDefault();
      $(this).parent('li').toggleClass( "active" )
    });
  
  timber.cache.$searchStore.on('click', function(evt) {
    evt.preventDefault();   
    timber.cache.$searchForm.toggleClass( "active" )
    timber.cache.$header.toggleClass( "active" )
    setTimeout(function() { $('input[name="q"]').focus() }, 0);
    
  })
  
   
  timber.cache.$closeSearch.on('click', function(evt) {
    evt.preventDefault();   
    timber.cache.$searchForm.toggleClass( "active" )
    timber.cache.$header.toggleClass( "active" )
  })
  
  
 
   
}


timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav_menudrop').find('a'),
      activeClass = 'active',
      focusClass = 'active-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      // force stop the click from happening
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    console.log('ho');
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav_menudrop').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);
	$('body').addClass('menu_hover_open');
    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $('body').removeClass('menu_hover_open');
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};





// Initialize Timber's JS on docready
$(timber.init);

isAppLoaded = true;
function scrollFX() {
  var $window = $(window),
    scrollTop = $window.scrollTop(),
    windowHeight = $window.height(),
    windowWidth = $window.width(),
    $boxes = $('[data-scroll-speed]'),
    $paraOne = $('.paraOne'),
    $paraTwo = $('.paraTwo'),
    tranY1 = $window.scrollTop() / 2.5 + 'px',
    tranY2 = $window.scrollTop() / 10000 + 'px',
    $header = $('header'),
    headerHeight = $('header').outerHeight(),
    $headerFX = $('header.lockFX'),
    $mainWrap = $('#mainWrap'),
    $scrollDown = $('.scrollDown'),
    altProdHeader = $('header.scrollFX');

  if($scrollDown.size() > 0) {
     if(scrollTop > 20) {
       $scrollDown.addClass('hidden');
     }else{
       $scrollDown.removeClass('hidden');
     }
  }
  if($headerFX.size() > 0 && 0) {
    var fullScreenSliderHeight = $('.fullScreenSlider').outerHeight();
    if(scrollTop > fullScreenSliderHeight) {	
      $header.addClass('locked');
      $mainWrap.css('margin-top', headerHeight);
    } else {
      $header.removeClass('locked');
      $mainWrap.css('margin-top', 0);
    }
  }

  if(altProdHeader.size() > 0) {
    if(scrollTop > 20) {
      altProdHeader.addClass('scrolled');
    } else {
      $header.removeClass('scrolled');
    }
  }

  $boxes.each(function() {
      var $this = $(this),
        oTop = scrollTop - $this.offset().top,
        scrollspeed = parseInt($this.data('scroll-speed')),
        val = -oTop / scrollspeed;
      $this.css('transform', 'translateY(' + val + 'px)');
    });

  //Hero
  if($paraOne.size() > 0) {
    $paraOne.css({
      transform: 'translateY(' + tranY1 + ')',
      MozTransform: 'translateY(' + tranY1 + ')',
      WebkitTransform: 'translateY(' + tranY1 + ')',
      msTransform: 'translateY(' + tranY1 + ')'
    });
    $paraTwo.css({
      transform: 'translateY(' + tranY2 + ')',
      MozTransform: 'translateY(' + tranY2 + ')',
      WebkitTransform: 'translateY(' + tranY2 + ')',
      msTransform: 'translateY(' + tranY2 + ')'
    });
  }
}

function openPopOut(target, t, line_item) {
  var $target = $(target),
    $popUps = $target.parents('#popUps'),
    $body = $('body'),
    $frame = $('#frame'),
    currentPos = $(window).scrollTop(),
    closePopout

  $popUps.css('background','rgba(0,0,0,0.8)');
  $popUps.addClass('active');
  $body.addClass('popOutFix');
  $frame.addClass('popOutFix');
  $target.show();
  if($target.attr('id') == 'gallery') {
    $popUps.css('background','rgba(255,255,255,0.8)');
    var scrolltoimg = $('.productThumbs').length ? $('.productThumbs a.active').attr('data-index_id') : '#indexImage_1';
    if(typeof scrolltoimg == "undefined"){
    	scrolltoimg = '#indexImage_1';
    }
    var $popUpsTop = $popUps.offset().top;
    //alert($popUpsTop);
    scrolltoimg = $target.find('img').filter(scrolltoimg).offset().top;
   // alert(scrolltoimg);
    scrolltoimg = scrolltoimg - $popUpsTop;
    $popUps.scrollTop(scrolltoimg);
  }
  setTimeout(function(){
    $target.addClass('active');
    
    //$('.shopify-section #popUps').scrollTop('0');
  },600);

  $('.closePopOut').click(function(e) {
    e.preventDefault();
    closePopout();
  });
  $target.find('form').submit(function(e) {
    closePopout();
  });
  closePopout = function() {
    $target.removeClass('active');
    $body.scrollTop(currentPos);
    setTimeout(function(){
      $popUps.removeClass('active');
      $body.removeClass('popOutFix');
      $frame.removeClass('popOutFix');
      $target.hide();
    },600);
  }
}

function setSlick(target) {
  //alert(target);
  target.each(function() {
    var $t = $(this),
      $n = $t.closest('.slickSlider').find('span.next'),
      $p = $t.closest('.slickSlider').find('span.prev'),
      $full = parseInt($t.attr('data-full'), 10),
      $tab = parseInt($t.attr('data-tab'), 10),
      $mob = parseInt($t.attr('data-mob'), 10),
      slides = $t.find('li').size(),
      $auto = $t.attr('data-auto')
    if($auto === "true") {
      $auto = true
    } else {
      $auto = false
    }
    var $time = parseInt($t.attr('data-timeout'), 10)
    if(slides >= 1) {
      var SlickSlider = $t.slick({
        autoplay: $auto,
        autoplaySpeed: $time,
        slidesToShow: $full,
        pauseOnHover: true,
        speed: 700,
        infinite: true,
        arrows: false,
        accessibility: false,
        dots: false,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1080,
            settings: {
              slidesToShow: $full
            }
          },
          {
            breakpoint: 736,
            settings: {
              slidesToShow: $tab
            }
          },
          {
            breakpoint: 568,
            settings: {
              slidesToShow: $mob
            }
          }
        ],
        touchDrag: true,
        mouseDrag: false
      });
      $n.click(function() {
        SlickSlider.slick('slickNext')
      });
      $p.click(function() {
        SlickSlider.slick('slickPrev')
      });
      var $sizeAllow = 3;
      
      if(window.innerWidth < 568){
      	$sizeAllow = 1;
      }
      if($t.find('li').size() <= $sizeAllow){
      	 $n.hide();
         $p.hide();
      }else{
      	 $n.show();
         $p.show();
      }
      //alert($sizeAllow);
      //alert($t.find('li').size());
      
    }
  });
}

function igramFeed(access_token) {
  var access_token = $('#instafeed').attr('data-access_token');
    targetDiv = $('#instafeed')
  if(targetDiv.size() > 0) {
    $.ajax({
      type: "GET",
      dataType: "jsonp",
      url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+ access_token,
      success: function(data) {
        var count = 5;
        for(var i = 0; i < count; i++) {
          targetDiv.append('<li class="flexItem oneQuarter"><a href="' + data.data[i].link + '" target="_blank"><img src="' + data.data[i].images.low_resolution.url + '" alt=""></a></li>');
        }
      }
    }).complete(function() {});
  }
}

function BS(target) {
  target.each(function() {
    $(this).backstretch($(this).attr('data-img'))
  });
}

function showNewsLetterLanding() {
  var timeOut = 5000
  setTimeout(function() {
    if(!$.cookie('initSignUp')) {
      openPopOut('#newsLetter');
      $.cookie('initSignUp', true, {
        expires: null
      })
    }
  }, timeOut);
}

function showNewsLetterLeaving() {
  if(!$.cookie('exitIntent')) {
    openPopOut('#newsLetter');
    $.cookie('exitIntent', true, {
      expires: null
    })
  }
}

function isotopeblog(){
  $('.blogListing').imagesLoaded(function(){
    $('.blogListing').isotope({
       itemSelector: 'li',
       percentPosition: true,
       layoutMode: 'fitRows'
    });
  });
}

$(document).ready(function() {
  	
  	
  $('#AddToCart').click(function(event) {
	
    var formIsValid = true;
    var message = "Please fill this out and you will be able to add the item to your cart.";
    $(this).find('[name^="customsize"]').filter('.required, [required="required"]').each(function() {
      $(this).removeClass('error');
      if (formIsValid && $(this).val() == '') {
        formIsValid = false;
        message = $(this).attr('data-error') || message;
        $(this).addClass('error');
      }
    });
    if (formIsValid){
      
      //return true;
    }
    else {
      alert(message);
      event.stopPropagation();
    }
  }).find('input, select, textarea').focus(function() {
    $(this).removeClass('error');
  });
});
/*$(window).bind("load", function() {
   $(".breadcrumb_hide").show();
})*/
$(window).load(function() {
  $(".breadcrumb_hide").show();
  setTimeout(function(){ $('.accentCollection').css('position','static');
	setTimeout(function(){ $('.accentCollection').css('position','relative'); }, 100) }, 500)
  
});

$(document).ready(function() {
  bgSliderUpdate();
  BS($('.backStretch'));
  igramFeed();
  scrollFX();

  //Account Actions
  $('.address-delete').click(function(e) {
    e.preventDefault();
    var $el = $(this),
    formId = $el.data('form-id'),
    confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
      Shopify.postLink('/account/addresses/' + formId, {'parameters': { '_method': 'delete' }});
    }
  });

  $('.editAddress').click(function(e) {
    e.preventDefault();
    var $id = $(this).attr('href').replace('#', '');
    $('#EditAddress_addNew').hide();
    $('.editAddressForm').hide();
    $('#EditAddress_' + $id).show();
    $('#EditAddress_' + $id).find('.cancelEdit').click(function(e) {
      e.preventDefault();
      $('#EditAddress_' + $id).hide();
      $('#EditAddress_addNew').show();
    });
  });

  //product page
  $('.accordHeaderLinks a').click(function(e) {
    e.preventDefault();
    var $t = $(this),
      section = $('.accordian section');
    $t.siblings().removeClass('active');
    $t.addClass('active');
    section.removeClass('active').filter($t.attr('href')).addClass('active')
  });

  //Pop Out functions
  $('.hasPop').click(function(e) {
    e.preventDefault();
    if($(window).width() > 736 || 1){
      var t = $(this),
        getPopout = t.attr('data-getPopout'),
        getPopout = $('#popUps .innerWrapper').filter(getPopout)
      t.addClass('active');
      openPopOut(getPopout, t);
	
    }
  });

  //back to top button
  $('.toTop').click(function(e) {
    e.preventDefault();
    $("html, body").animate({
      scrollTop: 0
    }, "1200");
  });

  //ajax update cart
  $('.qtyInput').change(function(){
    var qtyInput = $(this);
    Shopify.updateCartPage(qtyInput);
  });

  
  $(document).mouseleave(function(){
    showNewsLetterLeaving();
  });
  
	
});

$(window).load(function() {
  setSlick($('.slickSlider ul'));
  
  showNewsLetterLanding();
  
  $('main').animate({opacity: "1"},600)
});

$(window).scroll(function() {
  scrollFX();
});

$(window).resize(function() {
  
});
$(window).bind("load resize",function(e){
  //alert('loaded');
  $('body').removeClass('loading_body');
  $('body').removeClass('page_loading');
  BS($('.backStretch'));
  scrollFX();
  loadGridPadding();
  if($(window).width()<736){
    var findClass = $('.fullPageSectionsWrap .bgImage.fixedPosition');
    if(findClass.length){
    
      findClass.each(function(){
        $t = $(this);
        var bgurl = $t.css('background-image');
       // alert(bgurl);
        bgurl = bgurl.replace('url(', "");
        bgurl = bgurl.replace(')', "");                        
        $t.html('<img src='+bgurl+'>');
        $t.css('background-image','');
        $t.removeClass('bgImage');
        $t.removeClass('fixedPosition');
      })
      
    }
  }
});

bgSliderUpdate();

$(window).bind("load resize scroll touchmove",function(e){
  
  var footerHeight = $('.band_footer').height();
  if(footerHeight > 0){
  	footerHeight = footerHeight;
  }
  if($('.sticky_addcart').length && $(window).width() < 736){
    if($('.sticky_addcart.hide_mobile_sticky_varient').length){
      	footerHeight = footerHeight + 35;
    }else{
    	footerHeight = footerHeight + 69;
    }
  	
  }
  $('.footer_band_space').css('margin-bottom',footerHeight+'px');
  
  var headerClass = 'header.locked';
  
  
  
  if($(window).width()>736){
  	
    
      if($('body').hasClass('template-index')){
        var headerClass = '.strapLine';
      }

    
	
  }
  
  
  var wheight = $(window).height(),
      sections = $('.fullPageSection .fixedPosition'),
      top = $(window).scrollTop(),
      
      headerHeight = $(headerClass).height(),
      wrap = $('.fullPageSectionsWrap'),
      evt = e.originalEvent.type;
  //alert(headerHeight);
  if($('header.locked').length){
   	$('.header_wrapper').css('height',headerHeight+'px');
  }

  if(sections.size()>0 && $(window).width()>736){
    sections.each(function(){
      var t = $(this),
          wrap = t.parent().parent(),
          parent = t.parent('.fullPageSection'),
          ptop = parent.offset().top - headerHeight;
      if(evt === "load" || evt === "resize"){
        t.height(wheight-headerHeight);
      }
      if(top > ptop){
       $(this).addClass('screenLock').css('top',headerHeight);
      }else{
        $(this).removeClass('screenLock').css('top',0);
      };
      //$(this).attr('data-w',(top - headerHeight )+wheight);
      //$(this).attr('data-y',wrap.offset().top + wrap.height() -headerHeight);      
	  if((top - headerHeight )+wheight  > wrap.offset().top + wrap.height() -headerHeight ){
        wrap.addClass('atBottom');
      }else{
        wrap.removeClass('atBottom');
      }
    });
    
  }
  bgSliderUpdate();
  
});

function loadGridPadding(){
  $('.grid_sections, .main_video_full_wrap, .main_video_wrap').each(function(){
    if (window.innerWidth > 740) {
    	$(this).attr('style',$(this).attr('style_desktop'));
    }else{
    	$(this).attr('style',$(this).attr('style_mobile'));
    }
  });
}

function bgSliderUpdate(){
  
  if (window.innerWidth > 740) {
    $('.shopify-section').each(function(){
        var $t = $(this);
        var topPos = $t.offset().top;
        var winHeight = $(window).height();
        var heightToUpdate = $(window).height() - topPos;
       
      		heightToUpdate = heightToUpdate;
      

        $t.find('.preventOverflow').css('height',heightToUpdate+'px');
        if($t.find('.homepage-banner-video').length){
// 			var videoWidth = $t.find('.homepage-banner-video video').attr('width');
//           	var videoHeight = $t.find('.homepage-banner-video video').attr('height');
//           	var winWidth = window.innerWidth;
          
//           	var radioDiff = winWidth/videoWidth;
          
//           	var newHeight = radioDiff * videoHeight;
//           	//alert(winWidth);
//           	$t.find('.homepage-banner-video video').css('height',newHeight+'px');
        }
     });
     
  }
  
  if($('.homepage-banner-video').length){
    var isBigHeight = $('.homepage-banner-video').width()/$('.homepage-banner-video').height();
    
    var videoWidth = $('.homepage-banner-video video').attr('width');
    var videoHeight = $('.homepage-banner-video video').attr('height');
    var winWidth = window.innerWidth;
    var radioDiff = winWidth/videoWidth;

   	var newHeight = radioDiff * videoHeight;
    //alert(isBigHeight);
    //alert(newHeight+' - '+$('.homepage-banner-video').height());
    if(newHeight > $('.homepage-banner-video').height()){
      	
    	$('.homepage-banner-video video').css('height',newHeight+'px');	
    	$('.homepage-banner-video video').css('width','100%');	
    }else{
      	var radioDiff = $('.homepage-banner-video').height()/videoHeight;
      	//alert(radioDiff);
      	var newWidth = radioDiff * videoWidth; 
      	
    	$('.homepage-banner-video video').css('height',$('.homepage-banner-video').height()+'px');	
    	$('.homepage-banner-video video').css('width',newWidth+'px');	
    }
    
   
  }
}

// -----------------------------------------------------------
// Select wrapper

var formSelectInit = function($el) {

  if (!$el.parent('.form-select-wrapper').length && !$el.hasClass('product-single__variants')) {
    $el.wrap('<div class="form-select-wrapper" />').parent().prepend('<span class="selected-text">' + $el.find('option:selected').text() + '</span>');
  }

  var formSelectText = function() {
    var newOption = $el.find('option:selected').text();
    $el.siblings('.selected-text').text(newOption);

    if ($el.hasClass('address-country')) {
      $el.closest('form').find('.address-province').trigger('change');
    }
  }

  var formSelectEvents = function() {
    $el.on('change', function() {
      formSelectText();
    });
  }

  formSelectEvents();
}

$(window).load(function() {
  var $select = $('select');

  if ($select.length) {
    $select.each(function(i, select) {
      formSelectInit($(select));
    });
  }
});


// -----------------------------------------------------------
// Header cart

var headerCart = function($el) {
  var moneyFormat = $el.data('header-cart'),
      $empty = $el.find('.header-cart-empty');

  var headerCartToggle = function(direction) {
    if (direction === 'show') {
      $el.addClass('animating');
      setTimeout(function() {
        var windowWidth = $(window).width();
        $el.addClass('visible');
        if (windowWidth < 768) {
        	$('body').addClass('open_mobile_cart');
        }
        headerCartItemHeight();
        $('[data-product-form]').trigger('updateButton');
      }, 200);
    } else {
      $el.removeClass('visible');
      setTimeout(function() {
        $el.removeClass('animating');
      }, 200);
    }
  }

  var headerCartItemHeight = function() {
    var $headerCartItem = $el.find('[data-header-cart-item]');
    $headerCartItem.height('auto');

    $el.imagesLoaded(function() {
      $headerCartItem.each(function(i, el) {
        var $item = $(el);
        $item.height($item.height());
      });
    });
  }

  var headerCartUpdate = function(cart) {
	updateShippingBar(cart.total_price);
    var total = Shopify.formatMoney(cart.total_price, moneyFormat);
    $el.find('[data-header-cart-total]').html(total);
    $('#cartItemCount').text(cart.item_count);

    if (cart.item_count === 0) {
      setTimeout(function() {
        $empty.removeClass('hidden');
      }, 300);
    } else {
      $empty.addClass('hidden');
    }
  }

  var headerCartBuildProduct = function(cart, alreadyInCart, cartItem, quantity) {
    if (alreadyInCart) {
      $el.find('[data-header-cart-item="' + cartItem.id + '"]').find('input').val(quantity);
      
    } else {
	//alert('new');
      Shopify.getProduct(cartItem.handle, function(product) {
        var options = product.options;
        var variant;

        for (var i in product.variants) {
          if (product.variants[i].id === cartItem.id) {
            variant = product.variants[i];
          }
        }
        var varentTxt = '';
        for (var i in cartItem.variant_options) {
          if(cartItem.variant_options[i] != 'Default Title'){
          	varentTxt += '<span> <strong>'+cartItem.variant_options[i]+'</strong></span>'
          }
          
        }

        var variantOptions = '';
        if (!cartItem.variant_options.length === 1 && cartItem.variant_options[0] === 'Default Title') {
          for (var i in cartItem.variant_options) {
            console.log(cartItem.variant_options[i]);
            variantOptions = variantOptions ? variantOptions + '<span>' + options[i].name + ' <strong>' + cartItem.variant_options[i] + '</strong></span>' : '<span>' + options[i].name + ' <strong>' + cartItem.variant_options[i] + '</strong></span>';
          }
        }
        var img = cartItem.image;
        if(typeof Shopify.Image != "undefined"){
          
			img = Shopify.Image.getSizedImageUrl(cartItem.image, '160x');
        }
        var image = img,
            price = Shopify.formatMoney(cartItem.price, moneyFormat),
            quantityLabel = Theme.localization.cart.quantity;

        var variantQuantity = variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny'
                                ? variant.inventory_quantity
                                : 0;
        variantQuantity = variantQuantity === 0
                            ? ''
                            : 'max="' + variantQuantity + '"';
		
        	var linkAtag = '<a href="' + cartItem.url + '">' + cartItem.product_title + '</a>';
        
        $el.find('[data-header-cart-items]').append(
          '<article class="header-cart-item" data-header-cart-item="' + cartItem.id + '">' +
            '<a class="header-cart-item-image" href="' + cartItem.url + '">' +
              '<img src="' + image + '">' +
            '</a>' +
            '<div class="header-cart-item-info">' +
              '<h3>'+linkAtag+'</h3>' +
              '<span class="money">' + price + '</span>' +
              '<div class="header-cart-item-options" data-header-cart-options>' + varentTxt +
                variantOptions +
                '<span class="side_cart_qty">' +
                  quantityLabel +'<button class="slide_card_minus" type="button" data-header-cart-quantity-decrease="' + cartItem.id  +'">&minus;</button> ' +
          		  ' <strong><input type="text" min="0" ' + variantQuantity + ' value="' + cartItem.quantity + '" readonly></strong> ' +
                  '<button class="slide_card_plus" type="button" data-header-cart-quantity-increase="' + cartItem.id  +'">&plus;</button> ' +
                '</span>' +
              '</div>' +
            '</div>' +
          '</article>'
        );

        headerCartToggle('show');
      });
    }
  }

  var headerCartAddItem = function(variantId) {
    var alreadyInCart = false;

    if ($el.find('[data-header-cart-item="' + variantId + '"]').length) {
      alreadyInCart = true;
    }

    Shopify.getCart(function(cart) {
      var quantity;
      var cartItem;
      $.each(cart.items, function(i, el) {
        if (el.id === parseInt(variantId, 10)) {
          cartItem = el;
          quantity = el.quantity;
        }
      });

      headerCartUpdate(cart);
      headerCartBuildProduct(cart, alreadyInCart, cartItem, quantity);
    });
  }

  var headerCartEditQuantity = function(event, direction) {
    var $target = $(event.currentTarget),
        id = $target.data('header-cart-quantity-' + direction),
        $input = $target.closest('[data-header-cart-options]').find('input'),
        maxQuantity = $input.attr('max') ? parseInt($input.attr('max'), 10) : 1000000,
        quantity = parseInt($input.val(), 10);

    quantity = direction === 'increase' ? quantity + 1 : quantity - 1;
    quantity = quantity <= maxQuantity ? quantity : quantity - 1;
    $input.val(quantity);

    if (quantity === 0) {
      var $item = $target.closest('[data-header-cart-item]');
      headerCartRemove($item, id, headerCartUpdate);
    } else {
      Shopify.changeItem(id, quantity, function(cart) {
        headerCartUpdate(cart);
      });
    }
  }

  var headerCartRemove = function($item, id, callback) {
    Shopify.removeItem(id, function(cart) {
      $item.addClass('removed');

      setTimeout(function() {
        $item.remove();
      }, 200);

      callback(cart);
    });
  }

  var headerCartEvents = function() {
    $el.on('click', '[data-header-cart-quantity-increase]', function(event) {
      headerCartEditQuantity(event, 'increase');
    });

    $el.on('click', '[data-header-cart-quantity-decrease]', function(event) {
      headerCartEditQuantity(event, 'decrease');
    });

    $el.on('update', function(event, variantId) {

      headerCartAddItem(variantId);
    });
	
    $el.on('mouseleave', function() {
      headerCartToggle('hide');
    });
	
    $(window).on('resize', function() {
      headerCartItemHeight();
    });
  }
//alert('one');
  headerCartItemHeight();
  headerCartEvents();
}

$(window).load(function() {
  headerCart($('[data-header-cart]'));
});


// -----------------------------------------------------------
// Product add to cart

var productAdd = function($el) {

  var adding = false;

  var productUpdateButton = function(reset, success) {
    var $button = $('.add_to_cart_btn'),
        $buttonText = $button.find('#AddToCartText'),
        text = $button.attr('data-text');

    if (reset) {
      $button
        .removeClass('active')
        .attr('disabled', 'disabled');
      if (success) {
        $buttonText.text(text);
       // window.buttonInterval = setInterval(function() {
          $buttonText.text(text);
          $button
            .removeClass('disabled')
            .removeAttr('disabled');
       //   clearInterval(window.buttonInterval);
       // }, 4000);
      } else {
        $button
          .removeClass('disabled')
          .removeAttr('disabled');
      }
    } else {
      $button
        .addClass('active disabled')
        .attr('disabled', 'disabled');
    }
  }

  var productAddError = function(errors) {
    var error = $.parseJSON(errors.responseText);

    if (error.message === 'Cart Error') {
      $el.find('#AddToCart').append(
        '<span class="product-form-error">' + error.description + '</span>'
      );

      var $error = $el.find('.product-form-error');

      $error.addClass('animating');
      setTimeout(function() {
        $error.addClass('visible');
        productUpdateButton(true);
        adding = false;
        setTimeout(function() {
          $error.removeClass('visible');
          setTimeout(function() {
            $error.remove();
          }, 250);
        }, 3000);
      }, 200);
    }
  }

  var productAddItem = function() {
    if (!adding) {
      adding = true;
      productUpdateButton();

      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery('#prodForm').serialize(),
        dataType: 'json',
        success: function(response) {
          $('[data-header-cart]').trigger('update', response.variant_id);
          adding = false;

          

          
          	$('.header-cart').remove();
          	window.location.href = "/checkout";
            
                  var windowWidth = $(window).width();
                  if (windowWidth > 768 || 1) {
                      if(!$('body').hasClass('open_mobile_cart')){
                        $('body').addClass('open_mobile_cart');
                        return false;
                      }
                      
                  }



            
            
          
        },
        error: function(XMLHttpRequest, textStatus) {
          productAddError(XMLHttpRequest);
        }
      });
    }
  }

  var productAddEvents = function() {
    $el.on('click', '#AddToCart', function(event) {
      event.preventDefault();
      productAddItem(event);
    });

    $el.on('updateButton', function() {
      productUpdateButton(true, true);
    });
  }

  productAddEvents();
}



if ($('.home-kickstarter').length > 0) {

      // PIE

      $('.kickstarter__graphic.pie').html('<canvas id="kickstarter__pie--help" width="110" height="110"></canvas><canvas id="kickstarter__pie" width="110" height="110"></canvas>');

      var progress = 0,
          pieI = null,
          pieValue = Math.min( parseInt($('.kickstarter__graphic').data('value')) / 100, 1 ),
          pieColor = $('.kickstarter__graphic').data('color'),
          pieCanvas = document.getElementById('kickstarter__pie'),
          context = pieCanvas.getContext('2d'),
          centerX = pieCanvas.width / 2,
          centerY = pieCanvas.height / 2,
          radius = 45,
          progress = 0;

      context.lineWidth = 15;
      context.strokeStyle = pieColor;
      context.lineCap = 'round';

      pieI = setInterval(function() {
        progress = progress + 0.0025;
        context.clearRect(0, 0, pieCanvas.width, pieCanvas.height);
        context.beginPath();
        context.arc(centerX, centerY, radius, 0, (2*progress) * Math.PI, false);
        context.stroke();
        if (progress >= pieValue) {
          clearInterval(pieI);
        }
      }, 5);

      var pieCanvasHelp = document.getElementById('kickstarter__pie--help'),
          contextHelp = pieCanvasHelp.getContext('2d'),
          centerXHelp = pieCanvasHelp.width / 2,
          centerYHelp = pieCanvasHelp.height / 2,
          radiusHelp = 45;

      contextHelp.lineWidth = 15;
      contextHelp.strokeStyle = '#e9e9e9';
      contextHelp.lineCap = 'round';
      contextHelp.beginPath();
      contextHelp.arc(centerXHelp, centerYHelp, radiusHelp, 0, 2 * Math.PI, false);
      contextHelp.stroke();

      // BAR

      var barValue = Math.min(parseInt($('.kickstarter__graphic.bar').data('value')), 100);
      $('.kickstarter__graphic.bar').append('<div class="value"></div>');
      $('.kickstarter__graphic.bar .value').css('width', barValue + '%');

    }

$(document).ready(function(){
  	var isNoVarient = $('#ProductSelect').length;
    if($('.productInfo').length && isNoVarient == 0){
        

        var isInput = $('#prodForm > input').length;
        //$('.discount_price_per').hide();
        if(isInput == 0){
          //alert('here');
          $('.discount_price_per').show();
          var moneyFormat = $('.header-cart').data('header-cart');
          var offerPer = (($('#prodForm > input').attr('data-compare_at_price') - $('#prodForm > input').attr('data-price'))/$('#prodForm > input').attr('data-compare_at_price')) * 100;
          var offerAmount = $('#prodForm > input').attr('data-compare_at_price') - $('#prodForm > input').attr('data-price');
          offerAmount = Shopify.formatMoney(offerAmount, moneyFormat);
          offerPer = Math.round(offerPer);
          $('.discount_price_amount').text(offerAmount);
          $('.discount_price_percentage').text(offerPer);
        }
    }
  
  
});


jQuery(document).ready(function(){
    // This button will increment the value
    $('.qtyplus').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[id='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[id='+fieldName+']').val(currentVal + 1);
          	$('input[id='+fieldName+']').attr('value',currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[id='+fieldName+']').val(0);
          	$('input[id='+fieldName+']').attr('value',0);
        }
      
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[id='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[id='+fieldName+']').val(currentVal - 1);
          	$('input[id='+fieldName+']').attr('value',currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[id='+fieldName+']').val(0);
          	$('input[id='+fieldName+']').attr('value',0);
        }
    });
  $('.header-cart-wrapper-inner .header-cart-txt.header_cart_icon').click(function(){
  		var windowWidth = $(window).width();
        if (windowWidth > 768 || 1) {
          	if(!$('body').hasClass('open_mobile_cart')){
              $('body').addClass('open_mobile_cart');
              return false;
            }
        }
  });
  
  /*
  
  	$('.header-cart-wrapper-inner a').click(function(){
  		var windowWidth = $(window).width();
        if (windowWidth > 768 || 1) {
          	if(!$('.header-cart').hasClass('invisible')){
              $('.header-cart').toggleClass('invisible');
              $('.header-cart').toggleClass('visible');
              return false;
            }
        }
    	
 
  });

    $('.header-cart-wrapper-inner a').click(function(){
    var hidden = $('.header-cart.slide.invisible');

        hidden.animate({"right":"10px"}, "slow");

    });*/

  $('#mainWrap,.mobile_cart_close i').click(function(){
  		var windowWidth = $(window).width();
        if (windowWidth < 768 || 1) {
          if($('body').hasClass('open_mobile_cart')){
          	$('body').removeClass('open_mobile_cart');
          	$('.header-cart').removeClass('visible');
          	return false;
          }
          	
        }
 
  });
  
  

});
function openpopupnew(url,name) {
 // alert(url);
  window.open(url,name,'width=500,height=300');	
}
$(document).ready(function() {
	$('body').on('click', '.featuredImage.trigger_zoom', function(e) {
      	//alert('ya');
    	return false;
    });
	$('body').on('click', '.featuredImage.trigger_zoom', function(e) {
      	e.stopImmediatePropagation();
      var $links = $('.fancybox');
      var counter = 0;
      if($(this).parents('.productImages').find('.productThumbs a.active').length){
      	var counter = $(this).parents('.productImages').find('.productThumbs a.active').attr('data-counter');
      }
      $.fancybox.open( $links, {
          loop : true
      }, counter );
      	
      return false;
      	
    });
    $('body').on('click', '.featuredImage.trigger_zoom img1', function() {
    	var $zoomImageClass = '.zoom_images';
		
      	var counter = 0;
      	
      	var $links = $('.fancybox');
      	$.fancybox.open($links);
      
      	if($(this).parents('.productImages').find('.productThumbs a.active').length){
      		//$zoomImageClass = '.zoom_images.'+$(this).parents('.productImages').find('.productThumbs a.active').attr('data-image_zoom');
      		//var instance = $.fancybox.getInstance();

          	//var counter = $(this).parents('.productImages').find('.productThumbs a.active').attr('data-counter');
			//alert(counter);	
          	//instance.jumpTo( counter );
        }
      	//$(this).parents('.productImages').find('.zoom_images').trigger('click');
      	//$.fancybox.getInstance().jumpTo(counter);

      	//$(this).parents('.productImages').find(".zoom_images[data-image='"+$src+"']").trigger('click');
		//$.fancybox.open($($zoomImageClass));
      	
      	//$(this).parents('.productImages').find($zoomImageClass).trigger('click');
        
      	
      	
    });
  	$('.scroll_link_trigger').click(function(){

    //$('body').on('click', '.scroll_link_trigger', function() {
      //alert('hi');
      var $p =	$($(this).attr('href'));
      if($p.length){
      
      

        var heightToscroll = ($p.offset().top) - $('header.locked').height();


        $('html, body').animate({
          scrollTop: heightToscroll
        }, 500);

        return false;
        }
   });
  	$('.scroll_link1').click(function(){
      var $p =	$(this).parents('.shopify-section');

      var heightToscroll = ($p.offset().top + $p.height()) - $('body > header').height();


      $('html, body').animate({
        scrollTop: heightToscroll
      }, 500);
      
      return false;
   });
  	
	productAdd($('[data-product-form]'));
   
    function onPlayerStateChange(event) {
        if(!playing){
            alert('hi');
            playing = true;
        }
    }
  
    $('.popupVideo').click(function(){
		var $link = $(this).attr('href');
    	$('.popup_video iframe').attr('src',$link);
        $('.popup_video').addClass('active');
      	return false;
   	});
  	$('.close_video_popup').click(function(){
		var $p = $(this).parent();
      	$p.removeClass('active');
      	$p.find('iframe').attr('src','');
      	return false;
   	});
  	var userAgent = window.navigator.userAgent;

    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
      	if($('.shopify-section .preventOverflow').length){
          $('.shopify-section .preventOverflow').each(function(){
          	var $t = $(this);
            var $img = $t.css('background-image');
            $img = 'rgba(0, 0, 0, 0) '+$img+' no-repeat scroll 50% 50% / cover';
            //alert($t.css('background-image'));
            $t.css('background',$img);
          });
        }
    }
    else {
      	
       //alert('here');
    }
  	setTimeout(function() {
      if($('body').attr('data-async') == 'false'){
      	$('.open_warning').show();
      	$('body').addClass('open_warning_wrap');
        
      }
    }, 5000);
});

$(window).load(function() {
  
  	
  	var direction = 'horizontal';
  	var bxslider =$('#thumbs_list_frame').bxSlider({
     // pagerCustom: '#bx-pager-'+options.product_id,
      	infiniteLoop: false,
      	touchEnabled: true,
      	adaptiveHeight: true,
    	mode: direction,
    	maxSlides: 4,
    	minSlides: 4,
    	slideWidth: 400,
    	//moveSlides: 1,
    	hideControlOnEnd:true,
    	//preventDefaultSwipeY: true,
    	nextText:'<i class="fa fa-chevron-right"></i>',
    	prevText:'<i class="fa fa-chevron-left"></i>',
   	// easing :'linear'
    });
  
  $('.single-option-selector').on('change', function() {
    	//bxslider.goToSlide(5);
    //alert('hi');
    	
    	resetbxSliderOnChangeVarientPos(bxslider);
  });
  $(document).on('data-attribute-changed', function() {
    	//bxslider.goToSlide(5);
    
    	resetbxSliderOnChangeVarientPos(bxslider);
  });  
});
function resetbxSliderOnChangeVarientPos(bxslider){
      
      	setTimeout(function(){ 
                          
                         
          var currentImage = $("#thumbs_list_frame a[href='"+$('.featuredImage img').attr('src')+"']").attr('data-counter');
          $("#thumbs_list_frame a[href='"+$('.featuredImage img').attr('src')+"']").addClass('active');
          currentImage = parseInt(currentImage) + 1;
          //alert(currentImage);
          if(currentImage >= 5){
          	 var addCNo = 0;
            if(currentImage % 4 != 0){
                addCNo = 1;
            }
            currentImage = parseInt(currentImage/4);
        //
            currentImage = currentImage + addCNo;
            currentImage = currentImage - 1;
          }else{
          		currentImage = 0;
          }
         //	currentImage = 0;
		//	alert(currentImage);
          if(typeof bxslider.goToSlide === 'function'){
          	bxslider.goToSlide(currentImage);
          }
          

        }, 100);
      }
$(window).bind("load",function(e){
  $(document).trigger('data-attribute-changed');
  $('.accentCollection').css('position','static');
  setTimeout(function(){ $('.accentCollection').css('position','relative'); }, 100)
  $('.product_tab_heading a.active').removeClass('active');
  $('.tab_details.active').removeClass('active');
  $('.tab_mobile_trigger.active').removeClass('active');
  if (window.innerWidth > 740) {
  	
    
    $('.product_tab_heading a:first').addClass('active');
    $('.tab_details:first').addClass('active');
  }else{
    $('.tab_mobile_trigger:first').find('i').removeClass('fa-chevron-down');
	$('.tab_mobile_trigger:first').find('i').addClass('fa-chevron-up');
    $('.tab_mobile_trigger:first').addClass('active');
    $('.tab_details:first').show();
    $('.tab_details:first').addClass('active');
  }
});
      
$(document).ready(function(){
  
  $('.homepage-banner-video').click(function(){
      var $t = $(this);

      if($t.attr('data-video-status') == 'pause'){
		$t.find('i').attr('class','fa fa-pause');
        $t.find('video').get(0).play();
        $t.attr('data-video-status','play');
      }else{
        $t.find('i').attr('class','fa fa-play');
		$t.find('video').get(0).pause();
      	$t.attr('data-video-status','pause');
      }
  });
  
  $('.pupupImageWith').click(function(){
		$('#footer_gallery img').attr('src',$(this).attr('data-image'));
  });
  
  $('.accentCollection').css('position','static');
  setTimeout(function(){ $('.accentCollection').css('position','relative'); }, 100);
  $('.inpageVideo').click(function(){
    var $url = $(this).attr('href');
    var $p = $(this).parents('.homepage-image');
    var $height = $p.height();
    var $width = $p.width();
    var tag = '<div class="image_page_video"><iframe src="'+$url+'" allowfullscreen="" frameborder="0"></iframe></div>';
  	$p.append(tag);
    return false;
  });
  
  $(document).on('click', '.spr-summary-actions-newreview', function(event) {
    $('.accentCollection').css('position','static');
	setTimeout(function(){ $('.accentCollection').css('position','relative'); }, 100)
  });  
  $(document).on('click', '.spr-badge', function(event) {
    if($(".product_tab_heading a[data-tab-id='prodTabReview']").length){
      	if(window.innerWidth < 734){
      		$(".product_tab_heading a[data-tab-id='prodTabReview']").trigger('click');
            $('html,body').animate({
            scrollTop: $("a.tab_mobile_trigger[data-tab-id='prodTabReview']").offset().top - 50},
            'slow');
        }else{
        	$(".product_tab_heading a[data-tab-id='prodTabReview']").trigger('click');
            $('html,body').animate({
            scrollTop: $(".product_tab_heading a[data-tab-id='prodTabReview']").offset().top - 200},
            'slow');
        }
      	
    }else{
    	
        $('html,body').animate({
        scrollTop: $("#shopify-product-reviews").offset().top - 100},
        'slow');
    }
  });
  $('.tab_mobile_trigger').click(function(){
    var $this = $(this);
    
  	//$('.product_tab_heading a.active').removeClass('active');
    //$('.tab_details.active').removeClass('active');
    
    
    $('.accentCollection').addClass('remove_band_tmp');
    if($this.hasClass('active')){
      $this.removeClass('active');
      
      $this.find('i').addClass('fa-chevron-down');
      $this.find('i').removeClass('fa-chevron-up');
      $('#'+$this.attr('data-tab-id')).slideUp('fast',function(){ 
        $('#'+$this.attr('data-tab-id')).removeClass('active');
        setTimeout(function(){ $('.accentCollection').css('position','relative'); }, 100)
      });
    }else{
      $this.find('i').removeClass('fa-chevron-down');
      $this.find('i').addClass('fa-chevron-up');
      $this.addClass('active');
      $('#'+$this.attr('data-tab-id')).show();
      $('#'+$this.attr('data-tab-id')).addClass('active');
      $('#'+$this.attr('data-tab-id')).slideDown('fast',function(){
        
		$('.accentCollection').css('position','static');
        setTimeout(function(){ $('.accentCollection').css('position','relative'); }, 100)
      });
    }
    
    $('#'+$this.attr('data-tab-id')).addClass('active');
    $('.accentCollection').css('position','static');
	setTimeout(function(){ $('.accentCollection').removeClass('remove_band_tmp');
                          $('.accentCollection').css('position','relative');
                         }, 100)
    
    return false;
  });
  
  
  $(document).on('click', '.product_tab_heading a', function(event) {
    var $this = $(this);
    
  	$('.product_tab_heading a.active').removeClass('active');
    $('.tab_details.active').removeClass('active');
    
    $this.addClass('active');
    $('#'+$this.attr('data-tab-id')).addClass('active');
    $('.accentCollection').css('position','static');
	setTimeout(function(){ $('.accentCollection').css('position','relative'); }, 100)
    return false;
  });
	$('.productThumbs a').on('tap', function(evt) {
	//alert('hi');	
    var $img = $(this).attr('data-img');
    
    if($("#ProductSelect option[data-img='"+$(this).attr('data-img')+"']").length){
    	var varVal = $("#ProductSelect option[data-img='"+$(this).attr('data-img')+"']").attr('value');
      	
      	$('#ProductSelect-option-0 .product_varient_sel_radio_'+varVal).trigger('click');
    	
    	var varText = $("#ProductSelect option[data-img='"+$(this).attr('data-img')+"']").text();
		
      	var varText = varText.split(' — ');
      	varText = varText[0].trim(varText);	
      
      	var varText = varText.split('/');
      
      	varText = varText[0].trim(varText);
      	$('#ProductSelect-option-0 input[value="'+varText+'"]').trigger('click');
      //alert(varText);	
		//$("select#ProductSelect-option-0 option:contains('"+varText+"')").trigger('click');
      	//alert(varVal);	
      $("select#ProductSelect-option-0").val(varText);
      	$("select#ProductSelect-option-0").trigger('change');
    }	
    return false;
  });
  $('.productThumbs a').click(function(){
	//alert('hi');	
    var $img = $(this).attr('data-img');
    
    if($("#ProductSelect option[data-img='"+$(this).attr('data-img')+"']").length){
    	var varVal = $("#ProductSelect option[data-img='"+$(this).attr('data-img')+"']").attr('value');
      	
      	$('#ProductSelect-option-0 .product_varient_sel_radio_'+varVal).trigger('click');
    	
    	var varText = $("#ProductSelect option[data-img='"+$(this).attr('data-img')+"']").text();
		
      	var varText = varText.split(' — ');
      	varText = varText[0].trim(varText);	
      
      	var varText = varText.split('/');
      
      	varText = varText[0].trim(varText);
      	$('#ProductSelect-option-0 input[value="'+varText+'"]').trigger('click');
      //alert(varText);	
		//$("select#ProductSelect-option-0 option:contains('"+varText+"')").trigger('click');
      	//alert(varVal);	
      $("select#ProductSelect-option-0").val(varText);
      	$("select#ProductSelect-option-0").trigger('change');
    }	
    return false;
  });
 
  
  $('#view_scroll_right1').click(function(){
  	bxslider.goToNextSlide();
     return false;
  });
   $('#view_scroll_left1').click(function(){
  	bxslider.goToPrevSlide();
     return false;
  });
  
  $('#thumbs_list').trigger('goto', 0);
  if($('.clockNew').length && $('.timmer_data').length){
    CountDownTimer($('.timmer_data').attr('data-date'),$('.clockNew'),$('.timmer_data').attr('data-restart'));

    if($('.timmer_data').attr('data-stock_min_count') && $('.timmer_data').attr('data-stock_max_count') && $('.timmer_data').attr('data-stock_reset_time')){
      resetStock($('.product_stack_count'),parseInt($('.timmer_data').attr('data-stock_min_count')),parseInt($('.timmer_data').attr('data-stock_max_count')),parseInt($('.timmer_data').attr('data-stock_reset_time')));
    }

  }
  //$('#thumbs_list_frame').width(parseInt($('#thumbs_list_frame >li').outerWidth(true) * $('#thumbs_list_frame >li').length) + 'px');
  $('.search_top_trigger').click(function(){
  	$('.top_search_area').addClass('search_top_open');
    
  });
  $('.close_search').click(function(){
  	$('.top_search_area').removeClass('search_top_open');
    return false;
  });
  
  $('#accordion .panel-title a').click(function(){
    var $t = $(this);
    var $p = $t.parents('#accordion');
  	var isClosed = $t.hasClass('collapsed');
    if(isClosed){
        if($p.find('.in').length){
          	var $open = $p.find('.in')
			$open.slideUp( "slow", function() {
              $open.removeClass('in');
            });
          	$open.parents('.panel').find('.panel-title a').addClass('collapsed');
        }
      	var $toOpen = $t.parents('.panel').find('.panel-collapse');
      	$t.removeClass('collapsed');
      	$toOpen.slideDown( "slow", function() {
          $toOpen.addClass('in');
        });
      	
    }else{
    	var $open = $p.find('.in')
        $open.slideUp( "slow", function() {
          $open.removeClass('in');
        });
      	$open.parents('.panel').find('.panel-title a').addClass('collapsed');
    }
    return false;
  });
});
checkBrowser();

if($('.shipping_bar_top').length){
	updateShippingBar(parseInt($('.shipping_bar_top').attr('data-cart_amount')));
}
      
function updateShippingBar(total_amount){
  	//alert(total_amount);
    var moneyFormat = $('.shipping_bar_top').attr('data-header-currency');
  	//var moneyFormat = '';
    //alert(moneyFormat);
  	var actual_total_amount = total_amount/100;
  	var total_amount_format = Shopify.formatMoney(total_amount, moneyFormat);
  	
  		var shipping_bar_goad = 50;
  	
    var balance_amount = shipping_bar_goad - actual_total_amount;
    
    var shipping_bar_goad_format = Shopify.formatMoney(shipping_bar_goad * 100, moneyFormat);
	var balance_amount_format = Shopify.formatMoney(balance_amount * 100, moneyFormat);
  	
  
    var shipping_bar_initial_message = "Free Shipping from [amount]";
    var shipping_bar_progress_message = "More than [balance] to enjoy!";
    var shipping_bar_achieved_message = "Congratulations! You have Free Delivery!";
    
	shipping_bar_initial_message = shipping_bar_initial_message.replace("[amount]", shipping_bar_goad_format);
  	shipping_bar_progress_message = shipping_bar_progress_message.replace("[balance]", balance_amount_format);
    
  	if(actual_total_amount >= shipping_bar_goad){
    	$('.shipping_bar_top').html(shipping_bar_achieved_message);	
    }else if(actual_total_amount > 0){
    	$('.shipping_bar_top').html(shipping_bar_progress_message);	
    }else{
    	$('.shipping_bar_top').html(shipping_bar_initial_message);
    }
	
}
function checkBrowser() { 
     if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 ) 
    {
        
    }
    else if(navigator.userAgent.indexOf("Chrome") != -1 )
    {
        $('body').addClass('brow_chrome');
    }
    else if(navigator.userAgent.indexOf("Safari") != -1)
    {
        $('body').addClass('brow_safari');
    }
    else if(navigator.userAgent.indexOf("Firefox") != -1 ) 
    {
         
    }
    else if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true )) //IF IE > 10
    {
      
    }  
    else 
    {
       
    }
    }      

      function resetStock($ele,$min,$max,$time){
        var stockTimer;



        function updateStock(){
          var num = getRandomInt($min,$max);
          $ele.text(num);
        }
        //alert($time*1000);
        stockTimer = setInterval(updateStock, $time*1000);
      }

      function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }


      function CountDownTimer(dt, ele,restart)
      {
        do{
          var end = new Date(dt);
          var now = new Date();
          var distance = end - now;
          dt = end.getTime() + (parseInt(restart) * 1000);
          //alert(distance);
        }while(distance < 0)

          //alert(end.getTime());

          //var end = new Date(end.getTime() + (86400000));
          //alert(end.getTime());
          var _second = 1000;
        var _minute = _second * 60;
        var _hour = _minute * 60;
        var _day = _hour * 24;
        var timer;

        function showRemaining() {
          var now = new Date();
          var distance = end - now;
          var htmlDate = '';
          if (distance < 0) {

            clearInterval(timer);
            //document.getElementById(id).innerHTML = 'EXPIRED!';

            //return;
          }else{
            var days = Math.floor(distance / _day);
            var hours = Math.floor((distance % _day) / _hour);
            var minutes = Math.floor((distance % _hour) / _minute);
            var seconds = Math.floor((distance % _minute) / _second);

            htmlDate = days + 'jours ';
            htmlDate += hours + 'hrs ';
            htmlDate += minutes + 'mins ';
            htmlDate += seconds + 'secs';
          }
          ele.html(htmlDate); 

        }

        timer = setInterval(showRemaining, 1000);
      }
      if(window.location.href == 'https://www.magicmecanic.com/collections/frontpage'){
        window.location.href = 'https://www.magicmecanic.com/';
      }

 
/*===========================mob megamenu==================*/
      
     $( document ).ready(function() {

        $('.mob_menu_drop').click(function(){
        		$('.menu-arrow', this).toggleClass('m-arrow-up');
        		$('.menu-arrow', this).toggleClass('m-arrow-down');
        
           $(this).parent().find('.mob_subdrop').toggleClass('mob_subdrop_tog');
          
          });
       
       $('.header-cart-wrapper-inner').hover(function(){
        		$('body').toggleClass('menu_hover_open');
        		
          
          });

     });
 jQuery(document).scroll(function() {
  var y = $(this).scrollTop();
   
  if (y > 100) {
    $('.prod_form.prod_form_footer.sticky_addcart.bottom').fadeIn();
  } else {
    $('.prod_form.prod_form_footer.sticky_addcart.bottom').fadeOut();
  }
   
  if (y > 100) {
    $('.prod_form.prod_form_footer.sticky_addcart.top').fadeIn();
  } else {
    $('.prod_form.prod_form_footer.sticky_addcart.top').fadeOut();
  }
   

   
});

jQuery(document).scroll(function() {      
      var x = $(this).scrollTop();
   
  	   if (x > 0.1) {
          $('.main_header').addClass('scroll_bg');
        } else {
          $('.main_header').removeClass('scroll_bg');
        }

       if (x > 0.1) {
          $('.main_mega_heading').addClass('scroll_bg_txt');
        } else {
          $('.main_mega_heading').removeClass('scroll_bg_txt');
		}

});   
jQuery(document).ready(function(){
  
  	
  
  	
  
  
  
  
  

  

  //setTimeout(function(){ $('body').show(); }, 1000);
    // This button will increment the value
    $('.qtyplus').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        var fieldName = $(this).parent().find('.qty');
        // Get its current value
        var currentVal = parseInt(fieldName.val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            fieldName.val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            fieldName.val(0);
        }
      fieldName.trigger('change');
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        var fieldName = $(this).parent().find('.qty');
        // Get its current value
        var currentVal = parseInt(fieldName.val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            fieldName.val(currentVal - 1);
          	
        } else {
            // Otherwise put a 0 there
            fieldName.val(0);
        }
      	fieldName.trigger('change');
    });

        var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

      // Firefox 1.0+
      var isFirefox = typeof InstallTrigger !== 'undefined';

      // Safari 3.0+ "[object HTMLElementConstructor]" 
      var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

      // Internet Explorer 6-11
      var isIE = /*@cc_on!@*/false || !!document.documentMode;

      // Edge 20+
      var isEdge = !isIE && !!window.StyleMedia;

      // Chrome 1+
      var isChrome = !!window.chrome && !!window.chrome.webstore;

      // Blink engine detection
      var isBlink = (isChrome || isOpera) && !!window.CSS;
  	  
  	  var classtoAdd = 'browser_webkitt';
      if(isFirefox){
        var classtoAdd = 'browser_firefox';
      }
	  
  	  $('.header_wrapper').addClass(classtoAdd);
    });